import { render, staticRenderFns } from "./EmailTemplateMergeFields.vue?vue&type=template&id=098e50da"
import script from "./EmailTemplateMergeFields.vue?vue&type=script&lang=js"
export * from "./EmailTemplateMergeFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports